<template>
    <Base>
      <template v-slot:basecontent>
        <div class="rounded py-[16px] px-[24px] pb-[32px] w-[391px] bg-theme-grey">
         
          <div class="flex justify-center mb-4">
            <div class="flex-auto justify-center items-center mt-1 text-sm tracking-widest font-medium"> 
              <router-link class="text-theme-green mt-4" :to="{
                name: 'SelectBusiness'
              }"> BACK</router-link>
            </div>
            <div class="flex-auto w-64"> 
              <div class="text-2xl font-bold text-white mt-0 pl-[12px] text-left tracking-wider">New Business</div>
            </div>
          </div>

          <form @submit.prevent="createBusiness()" ref="business_add">
            <div :class="'input-wrapper ' + (businessForm.name.error_type)">
              <label class="mt-3 block label-text mb-1"> Business Name </label>
              <input
                class="shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline placeholder-theme-878686"
                placeholder="Cannabis Store"
                type="text"
                v-model="businessForm.name.value"
                @keyup="validateFields(['name'])"
              />
               <p class="field-error label-text mt-1" v-if="businessForm.name.error_message" v-text="businessForm.name.error_message"></p>
            </div>

            <div :class="'input-wrapper ' + (businessForm.slug.error_type)">
              <label class="mt-3 block label-text mb-1"> Business Slug </label>
              <input
                class="shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline placeholder-theme-878686"
                placeholder="Cannabis-Store"
                type="text"
                v-model="businessForm.slug.value"
                @keyup="validateFields(['slug'])"
              />
               <p class="field-error label-text mt-1" v-if="businessForm.slug.error_message" v-text="businessForm.slug.error_message"></p>
            </div>
            <button
              class="mt-8 bg-theme-green hover:bg-theme-darkgreen rounded w-[100%] text-[14px] text-bold text-white p-[8px] tracking-widest font-medium"
            >
              CREATE
            </button>
          </form>
        </div>
      </template>
    </Base>
</template>

<script lang="ts">
import { useRoute, useRouter } from 'vue-router'
import Helpers from '@/helpers';
import { ref, defineComponent } from "vue";
import Base from "@/views/Login/Base.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import BusinessApis from '@/controllers/BusinessApis';
import { useSnackbar } from "vue3-snackbar";

export default defineComponent({
  name: 'SelectBusiness',
  components: {
    Base,
  },

 setup() {
      const router = useRouter()
      const route = useRoute()
      const snackbar = useSnackbar();
      const businessForm = ref({
        name: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
        slug: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'min:3'],
        },
      });

    return {
      router,
      route,
      businessForm,
      snackbar
    };
 },
 
  watch:{
    // Slug cannot have whitespaces
    'businessForm.slug.value'(val){
      if(val) {
        val = val.toLowerCase();
        val = val.replaceAll(/\s/g,'').trim();
        this.businessForm.slug.value = val;
      } else {
        this.businessForm.slug.value = '';
      }
    },
  },

  methods: {

    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.businessForm, fields);
      // capture the fields
      this.businessForm = res.data;
      return res.error ? false : true;
    },

    // Create and set business
    async createBusiness() {
      let validate = await this.validateFields(['name', 'slug']);
      if(!validate) {
        return ;
      }
        
        this.va_spinner(true);
        // validate create new business
        let res = await BusinessApis.createBusiness({
          name: this.businessForm.name.value.trim(),
          slug: this.businessForm.slug.value,
        })
        this.va_spinner(false);
        this.snackbar.add({
          type: 'info',
          text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        if(res.status == 201) {
          // set this business as active business
          await this.va_setUserActiveBusiness(res.data.payload);
          this.router.push({
            name: 'Products'
          })
        }
    },


    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_setUserBusinesses: "auth/setUserBusinesses",
       va_setUserActiveBusiness: "auth/setUserActiveBusiness",
    })
  }

});

</script>
